import moment from 'moment';

const headerStyle = (center = true, width) => {
    let styles = { borderColor: '#a81933' };
    if (center) { styles = { ...styles, textAlign: 'center' }; }
    if (width) { styles = { ...styles, width: width, maxWidth: width }; }

    return styles;
};

const formatDate = (date) => {
    if (!date) return "";
    return moment(date).format("MM-DD-YYYY");
}

export const columns = [
    {
        dataField: 'franchiseInstance',
        text: 'Instance',
        sort: true,
        headerStyle: () => { return headerStyle(false, '100px'); },
    },
    {
        dataField: 'name',
        text: 'Office Name',
        sort: true,
        headerStyle: () => { return headerStyle(false, '150px'); },
    },
     {
        dataField: 'officeTypeName',
        text: 'Office Type',
        sort: true,
        headerStyle: () => { return headerStyle(false, '120px'); },
    },
    {
        dataField: 'status',
        text: 'Status',
        sort: true,
        headerStyle: () => { return headerStyle(false, '110px'); },
    },
    {
        dataField: 'openedOn',
        text: 'Start Date',
        sort: true,
        headerStyle: () => { return headerStyle(false, '110px'); },
        formatter: (_cell, row) => {
            return formatDate(row.openedOn);
        },
    },
    {
        dataField: 'closedOn',
        text: 'Current Exp Date',
        sort: true,
        headerStyle: () => { return headerStyle(false, '170px'); },
        formatter: (_cell, row) => {
            return formatDate(row.closedOn);
        },
        sortFunc: (a, b, order) => {
            // handle empty values
            if (!a && !b) return 0;
            if (!a) return 1;
            if (!b) return -1;

            const dateA = new Date(a).getTime();
            const dateB = new Date(b).getTime();

            if (order === 'asc') {
                return dateA - dateB;
            }
            return dateB - dateA;
        }
    },
    {
        dataField: 'terminationNotice',
        text: 'Termination Notice Period',
        sort: true,
        headerStyle: () => { return headerStyle(false, '130px'); },
    },
    {
        dataField: 'noticeDate',
        text: 'Termination Notice Date',
        sort: true,
        headerStyle: () => { return headerStyle(false, '120px'); },
        formatter: (_cell, row) => {
            return formatDate(row.noticeDate);
        },
    },
    {
        dataField: 'autoRenew',
        text: 'Auto Renew',
        sort: true,
        headerStyle: () => { return headerStyle(false, '120px'); },
        formatter: (cell) => (cell ? 'Yes' : 'No')
    },
    {
        dataField: 'monthToMonth',
        text: 'Month to Month',
        sort: true,
        headerStyle: () => { return headerStyle(false, '150px'); },
        formatter: (cell) => (cell ? 'Yes' : 'No')
    },
     {
        dataField: 'sqFt',
        text: 'Sq Ft',
        sort: true,
        headerStyle: () => { return headerStyle(false, '100px'); },
    },
    {
        dataField: 'pricePerSqFt',
        text: 'PPSF',
        sort: true,
        headerStyle: () => { return headerStyle(false, '100px'); },
    },
    {
        dataField: 'expenses',
        text: 'PPSF + Expenses',
        sort: true,
        headerStyle: () => { return headerStyle(false, '150px'); },
    },
    {
        dataField: 'propertyManagementContact',
        text: 'Property Manager Name',
        sort: true,
        headerStyle: () => { return headerStyle(false, '200px'); },
    },
    {
        dataField: 'propertyManagementContactPhone',
        text: 'Property Manager Phone',
        sort: true,
        headerStyle: () => { return headerStyle(false, '170px'); },
    },
    {
        dataField: 'propertyManagementContactEmail',
        text: 'Property Manager Email',
        sort: true,
        headerStyle: () => { return headerStyle(false, '260px'); },
    },
    {
        dataField: 'branchOfficeManagerName',
        text: 'Branch Manager',
        sort: true,
        headerStyle: () => { return headerStyle(false, '150px'); },
    },
    {
        dataField: 'branchOfficeManagerPhone',
        text: 'Branch Manager Phone',
        sort: true,
        headerStyle: () => { return headerStyle(false, '150px'); },
    },
    {
        dataField: 'branchOfficeManagerEmail',
        text: 'Branch Manager Email',
        sort: true,
        headerStyle: () => { return headerStyle(false, '190px'); },
    },
];

export const sorting = [{
    dataField: 'closedOn',
    order: 'asc'
}];
